// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__Jgedf","modalHeader":"Modal_modalHeader__B49Lf","modalBody":"Modal_modalBody__cL7xz","modalFooter":"Modal_modalFooter__eY2c9"};